// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2O81u","noInteraction":"EventWrapper_noInteraction__10TWs"};